import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "./Header";
import { Footer } from "./Footer";
import { CartDrawer } from "./CartDrawer";

export const StoreLayout = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return (
    <div className="min-h-screen bg-[#0C0A09] text-[#F5F0EB]">
      <div className="grain-overlay" />
      <Header />
      <main className="pt-[100px]">
        <Outlet />
      </main>
      <Footer />
      <CartDrawer />
    </div>
  );
};
